export enum DialogAction {
  SUBMIT = 'submit',
  CANCEL = 'cancel',
}
